<script>
import moment from "moment-timezone";
import {Line, mixins} from "vue-chartjs";

const {reactiveProp} = mixins;
export default {
  name: "LineChartJs",
  extends: Line,
  mixins: [reactiveProp],
  props: ["chartOptions"],
  data() {
    return {
      options: _.merge(
        {
          layout: {
            padding: {
              left: 10,
              right: 10,
              top: -20,
              bottom: 10
            }
          },
          elements: {
            point: {
              hitRadius: 3,
              backgroundColor: "rgba(236,32,95)"
            },
            line: {
              fill: false,
              borderWidth: 1,
              borderColor: "rgba(236,32,95)"
            }
          },
          scales: {
            yAxes: [
              {
                display: false,
                ticks: {
                  display: false,
                  beginAtZero: true,
                  suggestedMax: 100
                },
                gridLines: {
                  display: false
                }
              }
            ],
            xAxes: [
              {
                display: false,
                ticks: {
                  display: false,
                  callback: function (value, index, values) {
                    return moment(value).format("MM/DD/YYYY h:mm:ss a");
                  }
                },
                gridLines: {
                  display: false
                }
              }
            ]
          },
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: false
        },
        this.chartOptions
      )
    };
  },
  mounted() {
    // set width and height to parent div (if not set, chartjs default is width:400, height:400)
    this.$el.style.width = `${this.$el.parentElement.clientWidth}px`;
    this.$el.style.height = `${this.$el.parentElement.clientHeight}px`;
    // this.chartData is created in the mixin

    this.renderChart(this.chartData, this.options);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/chart/LineChartJs.vue